import { useEffect, useState } from 'react';
import { getPatientAndRelationPatients } from './utils';
import { track } from '../../tracking';
import AddRelationsModal from './AddRelationsModal';

export const FamilyIcon = ({ pid }: { pid: string }) => {
    const [showFamilyIcon, setShowFamilyIcon] = useState(false);
    const [isAddRelationsModalOpen, setIsAddRelationsModalOpen] = useState(false);

    useEffect(() => {
        getRelationPatients();
    }, []);

    const getRelationPatients = async () => {
        const patientAndRelationPatients = await getPatientAndRelationPatients(pid);
        if (!patientAndRelationPatients) {
            track('ERROR', { on: 'getPatientAndRelationPatients' });
            setShowFamilyIcon(false);
            return;
        }
        const { relationPatients } = patientAndRelationPatients;
        if (relationPatients.length > 0) {
            setShowFamilyIcon(true);
        } else {
            setShowFamilyIcon(false);
        }
    };

    if (!showFamilyIcon) {
        return null;
    }

    const toggleIsAddRelationsModalOpen = () => {
        setIsAddRelationsModalOpen(!isAddRelationsModalOpen);
        getRelationPatients();
    };

    return (
        <div className="h-full flex items-center">
            <button onClick={toggleIsAddRelationsModalOpen}>
                <svg
                    className="w-22 h-18 fill-darwin-neutral_new-800"
                    viewBox="0 0 22 17"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M6 4C5.4375 4 4.96875 3.71875 4.6875 3.25C4.40625 2.8125 4.40625 2.21875 4.6875 1.75C4.96875 1.3125 5.4375 1 6 1C6.53125 1 7 1.3125 7.28125 1.75C7.5625 2.21875 7.5625 2.8125 7.28125 3.25C7 3.71875 6.53125 4 6 4ZM5.75 16C5.75 16.5625 5.28125 17 4.75 17C4.1875 17 3.75 16.5625 3.75 16V9.03125L2.84375 10.5312C2.5625 11 1.9375 11.1562 1.46875 10.875C1 10.5938 0.84375 9.96875 1.125 9.5L2.9375 6.46875C3.5 5.5625 4.46875 5 5.53125 5H6.4375C7.5 5 8.46875 5.5625 9.03125 6.46875L10.8438 9.5C10.9375 9.65625 10.9688 9.8125 11 10C11 9.8125 11.0312 9.65625 11.125 9.5L12.8125 6.71875C13.4375 5.65625 14.5625 5 15.8125 5H16.1562C17.4062 5 18.5312 5.65625 19.1562 6.71875L20.8438 9.5C21.125 9.96875 20.9688 10.5938 20.5 10.875C20.0312 11.1562 19.4062 11 19.125 10.5312L18.0625 8.78125L19.2812 12.3438C19.375 12.6875 19.125 13 18.7812 13H18.25V16C18.25 16.5625 17.7812 17 17.25 17C16.6875 17 16.25 16.5625 16.25 16V13H15.75V16C15.75 16.5625 15.2812 17 14.75 17C14.1875 17 13.75 16.5625 13.75 16V13H13.1875C12.8438 13 12.5938 12.6875 12.7188 12.3438L13.9062 8.78125L12.8438 10.5312C12.5625 11 11.9375 11.1562 11.4688 10.875C11.1562 10.6875 11 10.375 11 10.0312C10.9688 10.375 10.8125 10.6875 10.5 10.875C10.0312 11.1562 9.40625 11 9.125 10.5312L8.25 9.03125V16C8.25 16.5625 7.78125 17 7.25 17C6.6875 17 6.25 16.5625 6.25 16V12H5.75V16ZM17.5 2.5C17.5 3.0625 17.1875 3.53125 16.75 3.8125C16.2812 4.09375 15.6875 4.09375 15.25 3.8125C14.7812 3.53125 14.5 3.0625 14.5 2.5C14.5 1.96875 14.7812 1.5 15.25 1.21875C15.6875 0.9375 16.2812 0.9375 16.75 1.21875C17.1875 1.5 17.5 1.96875 17.5 2.5Z" />
                </svg>
            </button>

            {pid && isAddRelationsModalOpen && (
                <AddRelationsModal
                    pid={pid}
                    closeMe={toggleIsAddRelationsModalOpen}
                    from="queue-family-icon-click"
                />
            )}
        </div>
    );
};
